// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"325":"ee9553a2","415":"ce308c95","622":"5bacb237","768":"5bacb237","964":"5bacb237"}[chunkId] + ".chunk.css";
};